import { render } from "./ConvocationsComponent.vue?vue&type=template&id=028d6801"
import script from "./ConvocationsComponent.vue?vue&type=script&lang=js"
export * from "./ConvocationsComponent.vue?vue&type=script&lang=js"

import "./ConvocationsComponent.vue?vue&type=style&index=0&id=028d6801&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__